import type { Category } from "@/types";

interface FilterPanelProps {
  categories: Category[];
  years: number[];
  tags: string[];
  selectedTypes: string[];
  selectedYears: number[];
  selectedTags: string[];
  onToggleType: (value: string) => void;
  onToggleYear: (value: number) => void;
  onToggleTag: (value: string) => void;
  onReset: () => void;
}

export default function FilterPanel({
  categories,
  years,
  tags,
  selectedTypes,
  selectedYears,
  selectedTags,
  onToggleType,
  onToggleYear,
  onToggleTag,
  onReset,
}: FilterPanelProps) {
  const chip = (active: boolean) =>
    `rounded-md border px-3 py-1.5 text-xs font-medium transition-colors ${
      active
        ? "border-primary-500 bg-primary-500 text-background-50"
        : "border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
    }`;

  const hasFilter = selectedTypes.length + selectedYears.length + selectedTags.length > 0;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-6">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-950">
          <i className="ri-filter-3-line text-lg text-primary-500"></i>
          筛选条件
        </h2>
        {hasFilter && (
          <button
            type="button"
            onClick={onReset}
            className="text-xs font-medium text-accent-600 transition-colors hover:text-accent-700"
          >
            重置
          </button>
        )}
      </div>

      <div className="mt-6">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-400">类型</h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {categories.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => onToggleType(item.id)}
              className={chip(selectedTypes.includes(item.id))}
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-400">年份</h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {years.map((year) => (
            <button
              key={year}
              type="button"
              onClick={() => onToggleYear(year)}
              className={chip(selectedYears.includes(year))}
            >
              {year} 年
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-foreground-400">标签</h3>
        <div className="mt-3 flex flex-wrap gap-2">
          {tags.map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => onToggleTag(tag)}
              className={`rounded-full border px-3 py-1 text-xs transition-colors ${
                selectedTags.includes(tag)
                  ? "border-accent-500 bg-accent-500 text-foreground-950"
                  : "border-background-300 bg-background-50 text-foreground-600 hover:border-accent-400"
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}